<template lang="html">
  <div class="like-container" :style="{'min-height':height+'px'}">
    <div class="like-row">
      <div v-for="item in recommend_list" :key="item.id">
        <div class="img-container" @click="go(item, '3')">
          <div class="img-div">
            <img class="logo" :src="$store.state.img_req_url + item.share_logo_path">
          </div>
          <!-- <img class="icon" :src="$store.state.static_img_url + 'pic/vip_tag.png'" v-if="item.only_vip == '1'"> -->
          <div class="title-container">
            <p class="title">{{item.title}}</p>
          </div>
        </div>
        <div class="news-list">
          <a href="javascript:void(0)" v-for="(news, index) in item.latest_content" :key="index" @click="contentRouter(news,item.uid)">
            <span class="date">{{news.publish_time | time_moment('MM-DD')}}</span> <p class="string" :style="{'text-indent': indent(news.title)}">{{news.title}}</p>
          </a>
        </div>
      </div>
    </div>
    <div class="like-flow">
      <div class="flow-item" v-for="(item, index) in like_list" :key="index">
        <!-- 快讯 -->
        <div class="no-pic-item" v-if="item.type == '1'">
          <router-link :to="{ name: 'NewsDetail', params: {uid: item.uid} }" class="title" target="_blank">{{item.title}}</router-link>
          <router-link :to="{ name: 'NewsDetail', params: {uid: item.uid} }" class="desc" target="_blank">{{item.summary}}</router-link>
          <div class="item-last-row">
            <p>{{item.publish_time | time_standard}}<span class="shu"></span><span v-if="item.tags">来自领域:</span><span v-if="tag_index < 5" v-for="tag,tag_index in returnMetaArr('dynview_tag',item.tags)" :key="tag.id">{{tag.name}}</span></p>
            <div>
              <i class="iconfont s active" title="取消收藏" v-if="item.is_collect" @click="cancelCollect('0', item.id, delCollectCb, index)">&#xe66f;</i>
              <i class="iconfont s" title="收藏" v-else  @click="addCollect('0', item.id, addCollectCb, index)">&#xe66f;</i>
              <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(item)" @on-popper-hide="haddleShareHide">
                  <i class="iconfont w">&#xe641;</i>
                  <div slot="content" class="share_cnt clear">
                    <div class="share_img"></div>
                    <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                  </div>
              </Poptip>
            </div>
          </div>
        </div>
        <!-- 报告 -->
        <div class="pic-item" v-if="item.type == '2'">
          <div class="left" @click="go(item, '2')">
            <div>
              <img class="logo" :src="$store.state.img_req_url + item.logo_path">
            </div>
            <img :src="$store.state.static_img_url + 'pic/list/u-li-type-2.png'" class="u-li-type">
          </div>
          <div class="right">
            <div>
              <a href="javascript:void(0)" class="title" @click="go(item, '2')">{{item.title}}</a>
              <a href="javascript:void(0)" class="desc" @click="go(item, '2')">{{item.summary}}</a>
            </div>
            <div class="item-last-row">
              <p>{{item.publish_time | time_standard}}<span class="shu"></span><span v-if="item.tags">来自领域:</span><span v-for="tag in returnMetaArr('dynview_tag',item.tags)" :key="tag.id">{{tag.name}}</span></p>
              <div>
                <i class="iconfont s active" title="取消收藏" v-if="item.is_collect" @click="cancelCollect('1', item.id, delCollectCb, index)">&#xe66f;</i>
                <i class="iconfont s" title="收藏" v-else  @click="addCollect('1', item.id, addCollectCb, index)">&#xe66f;</i>
              </div>
            </div>
          </div>
        </div>
        <!-- 专题 -->
        <div class="pic-item" v-if="item.type == '3'">
          <div class="left" @click="go(item, '3')">
            <div>
              <img class="logo" :src="$store.state.img_req_url + item.logo_path">
            </div>
            <img :src="$store.state.static_img_url + 'pic/list/u-li-type-1.png'" class="u-li-type">
          </div>
          <div class="right">
            <div>
              <a href="javascript:void(0)" class="title" @click="go(item, '3')">{{item.title}}</a>
              <a href="javascript:void(0)" class="desc" @click="go(item, '3')">{{item.summary}}</a>
            </div>
            <div class="item-last-row">
              <p>{{item.publish_time | time_standard}}<span class="shu"></span><span v-if="item.tags">来自领域:</span><span v-for="tag in returnMetaArr('dynview_tag',item.tags)" :key="tag.id">{{tag.name}}</span></p>
              <div>
                <i class="iconfont s active" title="取消收藏" v-if="item.is_collect" @click="cancelCollect('2', item.id, delCollectCb, index)">&#xe66f;</i>
                <i class="iconfont s" title="收藏" v-else  @click="addCollect('2', item.id, addCollectCb, index)">&#xe66f;</i>
                <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(item)" @on-popper-hide="haddleShareHide">
                    <i class="iconfont w">&#xe641;</i>
                    <div slot="content" class="share_cnt clear">
                      <div class="share_img"></div>
                      <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                    </div>
                </Poptip>
              </div>
            </div>
          </div>
        </div>
        <!-- 政策 -->
        <div class="policy-item" v-if="item.type == '4'">
          <p class="p1" @click="go(item, '4')"><span>政策</span>{{item.title}}</p>
          <div class="item-last-row">
            <p>{{item.publish_time | time_standard}}<span class="shu"></span><span v-if="item.tags">来自领域:</span><span v-for="tag in returnMetaArr('dynview_tag',item.tags)" :key="tag.id">{{tag.name}}</span></p>
            <div>
              <i class="iconfont s active" title="取消收藏" v-if="item.is_collect" @click="cancelCollect('3', item.id, delCollectCb, index)">&#xe66f;</i>
              <i class="iconfont s" title="收藏" v-else  @click="addCollect('3', item.id, addCollectCb, index)">&#xe66f;</i>
              <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(item)" @on-popper-hide="haddleShareHide">
                  <i class="iconfont w">&#xe641;</i>
                  <div slot="content" class="share_cnt clear">
                    <div class="share_img"></div>
                    <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                  </div>
              </Poptip>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="adv-item">
        <img src="http://temp.im/880x70">
      </div> -->
      <div class="more-button" v-if="show_more && !spin_show1" @click="changePage">
        <div>
          加载更多
        </div>
      </div>
      <div class="spin-group" v-if="show_more && spin_show1">
        <Spin fix>
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
      <p class="no-more-p" v-if="!show_more">亲，今日信息已阅读完，明日再来吧。</p>
    </div>
    <Spin fix v-if="spin_show">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import {
  guessLike,
  recommendThemeList,
  getNumOfreadReport
} from '../../../service'
import {
  userInfo
} from 'js/userInfo'
import {
  user_main_mixin
} from 'js/user_main_mixin'
// 1快讯，2报告，3专题
export default {
  mixins: [userInfo, user_main_mixin],
  inject: ['dynview_tag', 'cancelCollect', 'returnMetaArr', 'addCollect', 'showModal', 'is_vip', 'user'],
  data() {
    return {
      height: 0,
      spin_show: true,
      spin_show1: false,
      recommend_list: [], // 推荐
      like_list: [], // 流式列表
      page: 1,

      show_more: true
    }
  },
  computed: {
    subscribe_length() {
      if (this.$store.state.attention) {
        return this.$store.state.attention.subscribe.length
      } else {
        return 0
      }
    },
    /**
    * 专题桩体（免费0、会员专享1、付费解锁2、已购买3）
    *  theme_id专题ID type专题类型
    */
    // themeState() {
    //   return function(theme_item) {
    //     let theme_type_list = this.$store.state.theme_type
    //     if(theme_item.tags) {
    //       let type_item = theme_type_list.find((a) => theme_item.tags == a.id)
    //       if(type_item.price > 0 && theme_item.price > 0) {
    //         if(this.user_key) {
    //           if(this.isVIP) {
    //             return 1
    //           } else {
    //             let i = this.pay_theme_type.findIndex((a) => a.theme_type_id == theme_item.tags)
    //             if(i > -1) {
    //               return 3
    //             } else {
    //               return 2
    //             }
    //           }
    //         } else {
    //           return 2
    //         }
    //       } else {
    //         return 0
    //       }
    //     } else {
    //       return 0
    //     }
    //   }
    // }
  },
  methods: {
    async recommendThemeList() { // 推荐组
      let res = await recommendThemeList({
        size: 3,
        position_id: 1,
        latest_size: 3
      }, (error) => {
        this.$Message.error('请求错误')
      })
      if (res.status == 'success') {
        this.recommend_list = res.res
      } else {
        this.$Message.error(res.message)
      }
    },
    async guessLike() { // 流式列表
      let res = await guessLike({
        user_key: this.$store.state.user_key,
        page: this.page
      }, (error) => {
        this.$Message.error('请求错误')
      })
      if (res.status == 'success') {
        this.like_list = [...this.like_list, ...res.res]
        if (res.res.length < 10) {
          this.show_more = false
        }
        this.spin_show = false
        this.spin_show1 = false
      } else {
        this.$Message.error(res.message)
      }
    },
    haddleShare(item) {
      let share_link
      switch (item.type) {
        case '1': // 快讯
          share_link = 'https://vcbeat.top/News/newsDetail?uid=' + item.uid
          break;
          // case '2': // 报告
          //   share_link = 'https://www.baidu.com'
          //   break;
        case '3': // 专题
          share_link = window.location.protocol + '//' + window.location.host + '/mindex/specialDetail/' + item.uid
          break;
        case '4': // 政策
          share_link = window.location.protocol + '//' + window.location.host + '/mindex/policyDetail/' + item.uid
          break;
      }
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
    changePage() {
      this.page = this.page + 1
      this.spin_show1 = true
      this.guessLike()
    },
    addCollectCb(index) {
      this.like_list[index].is_collect = 1
    },
    delCollectCb(index) {
      this.like_list[index].is_collect = 0
    },
    contentRouter(news,item_uid) {
      if (news.content_type == '0') { // 0是文章
        window.open((process.env.NODE_ENV == 'development' ? 'http://192.168.1.104:8003/index.php/' : 'https://vcbeat.top/') + window.btoa(news.uid))
      } else if (news.content_type == '1') { // 1是快讯
        // this.$router.push({ name: 'NewsDetail', params: {uid: news.content[0].uid} })
        window.open((process.env.NODE_ENV == 'development' ? 'http://192.168.1.104:8081/newsDetail/' : this.$store.state.req_url+'/newsDetail/') + news.uid)
      } else if (news.content_type == '5') { // 1是政策
        // this.$router.push({ name: 'NewsDetail', params: {uid: news.content[0].uid} })
        window.open((process.env.NODE_ENV == 'development' ? 'http://192.168.1.104:8081/policyDetail/' : this.$store.state.req_url+'/policyDetail/') + news.uid)
      } else {
        window.open((process.env.NODE_ENV == 'development' ? 'http://192.168.1.104:8081/specialDetail/' : this.$store.state.req_url+'/specialDetail/') + item_uid)
      }
    },
    indent(s) { // 字符串前移
      if (s.indexOf('【') == 0) {
        return '-5px'
      } else {
        return '0px'
      }
    }
  },
  created() {
    this.recommendThemeList()
    this.guessLike()
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 155
    // window.onresize =  () => {
    //   this.height = document.documentElement.clientHeight - 195
    // }
  },
  watch: {
    subscribe_length(val) {
      if (val) {
        this.like_list = []
        this.page = 1
        this.guessLike()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/userMain.stylus'
ellipsis()
  display: -webkit-box
  overflow: hidden
  text-overflow: ellipsis
  word-break: break-all
  -webkit-box-orient: vertical
$img_height = 126px;
.like-container
  padding: 30px 20px;
  position: relative;
  .like-row
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 20px;
    >div
      commonBgColor(#1F2330, #ffffff);
      commonShadow(0px 3px 29px 0px rgba(0, 0, 0, 0.46), 2px 4px 20px 0px rgba(121,133,143,0.1))
      cursor: pointer;
      .img-container
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        >div
          overflow: hidden;
          &.img-div
            width: 280px;
            height: 166px;
            text-align: center;
        .logo
          width: 100%;
          height: 100%;
          transition: all .3s
          display: block;
          &:hover
            transform: scale(1.2);
        .icon
          position: absolute;
          top: -5px;
          left: -5px;
          width: 63px;
          height: 54px;
          // top: -13px;
          // left: -9px;
        .title-container
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          padding: 15px 15px 10px 15px;
          background-image: url('~pic/main_page/main-mask.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          display: flex;
          align-items: flex-end;
          height: 84px;
          .title
            font-weight: bold;
            max-height: 44px;
            font-size: 16px;
            color: #ffffff;
            line-height: 24px;
            -webkit-line-clamp: 2;
            ellipsis()
      .news-list
        padding: 15px;
        a
          display: flex;
          font-size: 12px;
          commonColor(#BCBDC1, #333)
          position: relative;
          .date
            padding: 0 2px;
            margin-right: 4px;
            border: 1px solid;
            commonColor(#8F8F8F, #8590A6)
            commonBorderColor(#303649, #F6F6F6)
          .string
            flex: 1;
            height: 16px;
            line-height: 16px;
            -webkit-line-clamp: 1;
            ellipsis();
            // margin: 0 8px 0 12px;
          // &:before
          //   content: '';
          //   background: rgba(250, 122, 80, 1);
          //   width: 4px;
          //   height: 4px;
          //   display: inline-block;
          //   border-radius: 50%;
          //   position: absolute;
          //   top: 5px;
          &+a
            margin-top: 10px;
          &:hover
            color: rgba(250, 122, 80, 1)
  .like-flow
    // padding: 0 20px;
    .flow-item
      padding: 20px 0;
      &+.flow-item
        border-top: 1px solid;
        commonBorderColor(#40444F, #f3f3f3)
    .item-last-row
      display: flex;
      justify-content: space-between;
      align-items: center;
      p
        commonColor(#797B83, #999999);
        font-size: 12px;
        span
          margin-left: 10px;
          &.shu
            position: relative
            padding-left: 1px
            &:before
              content: ''
              position: absolute
              width: 1px
              height: 10px
              commonBgColor(#797B83, #e9e9e9)
              top: 2px
              left: 0
      div
        flex: 0 0 44px
      div,>>>.ivu-poptip
        i
          width: 18px;
          height: 18px;
          text-align: center;
          line-height: 18px;
          commonColor(#ADAFB4, #cccccc)
          commonBgColor(#343844,#f3f3f3)
          border-radius:2px;
          font-size: 10px;
          display: inline-block;
          cursor: pointer;
          &.s:hover,&.s.active
            color: #fff;
            background:rgba(250, 122, 80, 1);
          &.w:hover,&.w.active
            color: #fff;
            background:#63BF61;
        .ivu-poptip-inner
          border-radius: 0
          .share_cnt
            padding: 10px 20px 10px 10px
            .share_img
              width: 80px
              height: 80px
              float: left
              background: #f0f0f0
            p
              line-height: 20px
              color: #666
              float: right
              margin-top: 20px
              font-size: 14px
        .ivu-poptip-popper
          transform: translate(13px, 0)
      >>>.ivu-poptip
        i
          margin-left: 8px;
    .no-pic-item
      .title
        commonColor(#fff, #333);
        font-size: 16px;
        line-height:24px;
        display: block;
        font-weight: bold;
        &:hover
          color: rgba(250, 122, 80, 1)
      .desc
        margin-top: 10px;
        font-size:14px;
        line-height:22px;
        commonColor(#BCBDC1, #666)
        margin-bottom: 20px;
        display: block;
        &:hover
          color: rgba(250, 122, 80, 1)
    .pic-item
      display: flex;
      .left
        margin-right: 20px;
        position: relative;
        >div
          overflow: hidden;
          font-size: 0;
        .u-li-type
          position: absolute
          top: 4px
          right: -4px
        .logo
          height: $img_height;
          width: 216px;
          transition: all .3s;
          &:hover
            transform: scale(1.2);
        .icon
          position: absolute;
          top: -7px;
          left: -6px;
      .right
        flex:1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title
          commonColor(#fff, #333)
          font-size: 16px
          line-height:24px
          max-height: 48px
          display: -webkit-box
          overflow: hidden
          text-overflow: ellipsis
          word-break: break-all
          -webkit-box-orient: vertical
          -webkit-line-clamp: 2
          font-weight: bold;
          &:hover
            color: rgba(250, 122, 80, 1)
        .desc
          margin-top: 10px
          font-size: 14px
          line-height:16px
          max-height: 16px
          display: -webkit-box
          overflow: hidden
          text-overflow: ellipsis
          word-break: break-all
          -webkit-box-orient: vertical
          -webkit-line-clamp: 1
          commonColor(#BCBDC1, #666)
          display: block;
          &:hover
            color: rgba(250, 122, 80, 1)
    .policy-item
      .p1
        font-size:16px
        commonColor(#FFFFFF, #333333)
        cursor: pointer
        font-weight: 600
        line-height:22px
        margin: -3px 0
        span
          margin-right: 21px
          position: relative
          &:before
            content: ''
            position: absolute
            width: 1px
            height: 15px
            commonBgColor(#40444F, #E9E9E9)
            right: -11px
            top: 1px
        &:hover
          color: rgba(250, 122, 80, 1)
          span:before
            background-color: rgba(250, 122, 80, 1)
      .item-last-row
        margin-top: 20px
    .adv-item
      border-top: 1px solid;
      border-bottom: 1px solid;
      commonBorderColor(#40444F, #f3f3f3)
      padding: 20px 0;
      img
        width: 100%;
        height: 70px;
    .spin-group
      position: relative;
      padding: 30px;
      border-top: 1px solid;
      commonBorderColor(#40444F, #f3f3f3)
      >>>.ivu-spin-fix
        top: 10px;
</style>
